import React from 'react';
import { Conversation } from '../../../ReferralReport/Conversation/Conversation';

export const TabJournalAndDiscussion: React.FC = () => {
  return <Conversation />;
};
